var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
    'snap-nav-item',
    {
      'snap-nav-item--disabled': _vm.disabled,
      active: _vm.active
    }
  ],on:{"click":_vm.handleClick}},[_c('span',{staticClass:"item-label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }